export const IGBlack = () => {
    return (
        <svg
            width="20"
            height="21"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <path
                d="M10 13.5864C11.6569 13.5864 13 12.2433 13 10.5864C13 8.92957 11.6569 7.58643 10 7.58643C8.34315 7.58643 7 8.92957 7 10.5864C7 12.2433 8.34315 13.5864 10 13.5864Z"
                fill="#140101"
            />
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M4 0.586426C1.79086 0.586426 0 2.37729 0 4.58643V16.5864C0 18.7956 1.79086 20.5864 4 20.5864H16C18.2091 20.5864 20 18.7956 20 16.5864V4.58643C20 2.37729 18.2091 0.586426 16 0.586426H4ZM10 15.5864C12.7614 15.5864 15 13.3478 15 10.5864C15 7.825 12.7614 5.58643 10 5.58643C7.23858 5.58643 5 7.825 5 10.5864C5 13.3478 7.23858 15.5864 10 15.5864ZM16 4.58643C16 5.13871 15.5523 5.58643 15 5.58643C14.4477 5.58643 14 5.13871 14 4.58643C14 4.03414 14.4477 3.58643 15 3.58643C15.5523 3.58643 16 4.03414 16 4.58643Z"
                fill="#140101"
            />
        </svg>
    );
};
